import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import styles from './styles.module.scss'
import { isMobileScreen } from 'srcReact/helpers/utils'
import Icon from 'srcReact/components/icons/Icon'

const Tabs = ({
  initialActive,
  type,
  aligned,
  children,
  className,
  contentClassName,
  rightContent,
  hasCountInLabel = false
}) => {
  const [mobile, setMobile] = useState(isMobileScreen())
  const [activeTab, setActiveTab] = useState(children && children[initialActive] && children[initialActive].props.label)

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange)
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [])

  useEffect(() => {
    setActiveTab(children[initialActive].props.label)
  }, [initialActive])

  const handleWindowSizeChange = () => {
    setMobile(isMobileScreen())
  }

  return (
    <div className={`${styles.tabWrapper} ${className}`}>
      <div className={`${styles.tabs} ${styles[type]} ${styles[aligned]}`}>
        <ol className={`${styles.tabList}`}>
          {children &&
            children.map((child) => {
              const { label, iconName, onClick, disabled, hidden, badge, inactive } = child.props

              let itemClassName = styles.tabListItem
              //in below condition, split is used to ignore count text in tab e.g  Members (13), Leadership (5)
              if ((hasCountInLabel && activeTab.split(' ')[0] === label.split(' ')[0]) || activeTab === label) {
                itemClassName += ` ${styles.tabListActive}`
              }

              return (
                <li
                  key={label}
                  className={`${itemClassName} ${disabled && styles.disabledTabItem} ${
                    hidden && styles.hiddenTabItem
                  } ${inactive && styles.inactiveTabItem}`}>
                  <button
                    type='button'
                    tabIndex={0}
                    disabled={disabled}
                    className={styles.liButton}
                    {...(!disabled
                      ? {
                          onClick: () => {
                            if (onClick && !inactive) {
                              setActiveTab(label)
                              onClick()
                            }
                          }
                        }
                      : {})}>
                    {!mobile && iconName && <Icon styleModifier={styles.tabIcon} name={iconName} />}
                    {label}
                  </button>
                  {badge >= 1 && <span className={styles.badge}>{badge}</span>}
                </li>
              )
            })}
        </ol>
        {rightContent ? rightContent : null}
      </div>
      <div className={`${styles.tabContent} ${contentClassName}`}>
        {children &&
          children.map((child) => {
            //in below condition, split is used to ignore count text in tab e.g  Members (13), Leadership (5)
            if (hasCountInLabel) {
              if (child.props.label.split(' ')[0] !== activeTab.split(' ')[0]) {
                return undefined
              } else {
                return child.props.children
              }
            } else if (child.props.label !== activeTab) {
              return undefined
            }
            return child.props.children
          })}
      </div>
    </div>
  )
}

Tabs.propTypes = {
  initialActive: PropTypes.number,
  aligned: PropTypes.string,
  type: PropTypes.oneOf(['default', 'boxed']),
  children: PropTypes.node.isRequired,
  rightContent: PropTypes.node,
  className: PropTypes.string,
  contentClassName: PropTypes.string
}

Tabs.defaultProps = {
  initialActive: 0,
  aligned: 'centered',
  type: 'default'
}

export default Tabs
